import type { ReactNode } from "react";
import { C, font } from "../theme";
import { ApogeuLogo } from "../components/ApogeuLogo";

export type InviteValidationState =
  | { kind: "loading" }
  | { kind: "unavailable"; message: string }
  | { kind: "error"; message: string };

interface InviteValidationScreenProps {
  state: InviteValidationState;
  email?: string;
  children?: ReactNode;
}

/** Tela única para os estados bloqueantes do convite (inválido/expirado/usado/revogado/erro). */
export function InviteValidationScreen({ state, email, children }: InviteValidationScreenProps) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: C.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        fontFamily: font,
        textAlign: "center",
      }}
    >
      <ApogeuLogo width={140} />
      <div style={{ fontSize: 20, fontWeight: 700, letterSpacing: 1.2, color: C.ink, marginTop: 22 }}>
        {state.kind === "loading" ? "VALIDANDO CONVITE" : state.kind === "error" ? "ERRO AO VALIDAR" : "CONVITE INDISPONÍVEL"}
      </div>
      {email && state.kind !== "loading" && (
        <div style={{ fontSize: 12, letterSpacing: 1, color: C.light, marginTop: 8, textTransform: "lowercase" }}>{email}</div>
      )}
      <div style={{ fontSize: 13, color: C.gray, marginTop: 10, maxWidth: 380, lineHeight: 1.6 }}>
        {state.kind === "loading" ? "Aguarde um instante..." : state.message}
      </div>
      {children}
    </div>
  );
}